module.exports = __webpack_public_path__ + "img/ROUND SHADES LIME.4517fd7.svg";